import React, { useEffect } from "react";

import { Card, Typography, Row, Col, Form, Layout } from "antd";
import Correo from "../../../components/Public/CorreoPassword/Correo";
import "../../../assets/css/correo.css";
import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";
import { useDispatch } from "react-redux";
const { Paragraph, Text } = Typography;

export const EnviarCorreoPage = () => {
  const { Item } = Form;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModalLogin());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout className="body-style">
      <Row align="center" className="top-row">
        <Col span={6} xxl={6} xl={14} lg={14} md={14} sm={14} xs={14}>
          <Card className="card-correo">
            <Item className="form-correo">
              <Card className="card-titulo">
                <Typography>
                  <Text className="titulo-correo">Recuperar mi contraseña</Text>
                  <Paragraph>
                    <p className="parrafo-correo">
                      Ingresa el correo electrónico que registraste y recibirás
                      un mensaje con las instrucciones para restablecer la
                      contraseña.
                    </p>
                  </Paragraph>
                </Typography>
              </Card>
              {/* Formulario para recuperar contraseña */}
              <Correo />
            </Item>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};
